/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */

/**
 * Configuración de MSAL para autenticación con Microsoft Entra ID.
 * Define los parámetros de conexión con Azure AD y los permisos solicitados.
 */

/**
 * Configuración principal de MSAL para la autenticación.
 */
export const msalConfig = {
  auth: {
    // ID de cliente de la aplicación en Azure AD
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    // Endpoint de autenticación de Microsoft (tenant específico)
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    // URI de redirección tras autenticación
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    // Almacenamiento de tokens en sessionStorage (se borra al cerrar navegador)
    cacheLocation: "sessionStorage",
    // No usar cookies para almacenar estado de autenticación
    storeAuthStateInCookie: false,
  },
};

/**
 * Configuración de la solicitud de login.
 * Define los permisos (scopes) que la aplicación necesita.
 */
export const loginRequest = {
  // Permiso para acceder a la API backend
  scopes: [process.env.REACT_APP_API_SCOPE],
};
